import { featureFlagRequests } from "@/api/(requests)/featureFlagTyped";
import { getFeatureFlagValue } from "@/features/feature-flag/helpers/get-flag-value";

import { initialConfigsState } from "../reducers/configsReducer";

import * as actionTypes from "./actionTypes";

const configsLoaded = (configs) => {
  return {
    configs: configs,
    type: actionTypes.CONFIGS_LOADED,
  };
};

export const loadConfigs = () => async (dispatch) => {
  let configs = await Promise.all(
    Object.keys(initialConfigsState).map(async (featureName) => {
      const searchParams = { feature_name: featureName };
      let featureFlagValue;

      try {
        featureFlagValue = await featureFlagRequests.get_feature_flag({
          context: { showLoader: false },
          searchParams,
        });
      } catch (e) {
        console.log(e);
        featureFlagValue = FEATURE_FLAG_DEFAULTS[featureName];
        console.log("Error retrieving feature flag, using default", featureFlagValue);
      }

      return {
        name: featureName,
        value: featureFlagValue,
      };
    }),
  );

  configs = configs.reduce((obj, feature) => {
    obj[feature.name] = getFeatureFlagValue(feature);

    return obj;
  }, {});

  dispatch(configsLoaded(configs));
};

/**
 *
 * !!! Remember to update these defaults when making changes to DB configs.
 *
 */

const UNINSURED_PRICES_DEFAULT = {
  diagnostic_interview: {
    first_session: "$300",
  },
  medication_management: {
    medication_intake: "$165",
    standard_sessions: "$48 - $155",
  },
  therapy: {
    add_thirty: "$55 - $70",
    forty_five_min: "$75 - $105",
    sixty_min: "$110 - $150",
    thirty_min: "$60 - $80",
  },
};

const ENABLED_CARRIER_PAYWALL_DEFAULT = {
  enabled_carriers: {
    Aetna: false,
    "Aetna Medicare": false,
    Anthem: false,
    "Anthem Medicare": false,
    Cigna: false,
    "Emblem Health": false,
    "Emblem Medicare": false,
    "Empire Plan (New York State)": false,
    "Excellus BlueCross BlueShield": false,
    "Excellus Medicare": false,
    "Highmark/BlueShield of Northeastern New York": false,
    "Highmark/BlueShield of Northeastern New York \u2013 Medicare": false,
    Humana: false,
    "Humana Medicare": false,
    "Humana Military/Tricare": false,
    "Insurance isn't on the list": false,
    Magnacare: false,
    "Martin's Point/MHACO (MaineHealth Accountable Care Organization)": false,
    Medicare: false,
    "No insurance": false,
    "United Healthcare Commercial": false,
    "United Healthcare Community Plan": false,
    "United Healthcare Medicare": false,
    "Wellcare/Today's Options": false,
  },
};

/**
 *
 * !!! Remember to update these defaults when making changes to DB configs.
 *
 */

const FEATURE_FLAG_DEFAULTS = {
  ENABLED_CARRIER_PAYWALL: ENABLED_CARRIER_PAYWALL_DEFAULT,
  UNINSURED_PRICES: UNINSURED_PRICES_DEFAULT,
};
